/* eslint-disable */
/**
 * @fileoverview
 *
 * 本文件词条由 `tea scan` 命令扫描生成，请勿手动编辑
 *
 * 国际化方案，请参考文档 http://tapd.oa.com/tcp_access/markdown_wikis/0#1020399462008817031
 */

/**
 * @type {import('@tea/app').I18NTranslation}
 */
 var translation = {
  "k_002rp73": "Mute",
  "k_002uuns": "Callbacks",
  "k_002uzrd": "Preview",
  "k_002vt4q": "Description",
  "k_003m86e": "Reset",
  "k_003o97r": "SD",
  "k_003oe04": "Terminate",
  "k_003p3qd": "FHD",
  "k_003p7js": "HD",
  "k_003pb7f": "Stop",
  "k_003qil7": "Pause",
  "k_003r4iv": "Subtitles",
  "k_003rhvm": "Full screen",
  "k_003s38r": "More",
  "k_00eum2f": "The license expired. Check the expiration time.",
  "k_00h11hy": "This feature allows you to flip the video image by right-clicking on the video and selecting \"Mirror\".",
  "k_00p0tks": "Failed to verify psign",
  "k_01errd5": "Invalid request format",
  "k_027yrcm": "Notes",
  "k_02o97ea": "Multi-language",
  "k_031umgo": "This browser does not support H.264 codec encoding",
  "k_039i528": "Custom UI",
  "k_03aj50y": "Error code",
  "k_03ioh9m": "Multi-instance",
  "k_03kvfyz": "Error decrypting the video",
  "k_0446i6j": "For better user experience, we recommend you use the player together with <1>VOD<\/1> and <3>CSS<\/3>.",
  "k_04hab2t": "You can also set the size using CSS. The properties can be in pixels or percentages, such as width:\"100px\" or width:\"100%\" .",
  "k_05lmeyf": "Getting a CSS playback URL",
  "k_05pup04": "Notes",
  "k_06pffjb": "The playback stopped because the video file is corrupted or the video used a feature not supported by the browser",
  "k_07wojgz": "WebRTC, FLV, and HLS are supported for live stream playback. HLS, FLV, and MP4 are supported for video on demand.",
  "k_080cf2m": "This feature only works for videos that have been transcoded in the VOD console. You need to pass in the AppID of your VOD account and the video's file ID.",
  "k_085uit9": "Refer to the code on the right to add subtitles to videos. For adaptive bitrate streaming, you can also add subtitles in the cloud in the VOD console or using a <1>TencentCloud API<\/1>.",
  "k_08x2l72": "Start\/Resume",
  "k_09fuhzz": "Because untranscoded videos may experience compatibility issues during playback, we recommend you transcode your videos before playback.",
  "k_09pvs4c": "Player size",
  "k_0b468j9": "You can enable messages for video quality change when initializing the player. For details, see the code above.",
  "k_0cqnwb5": "Unmute",
  "k_0dybyzp": "This feature is only supported on desktop browsers.",
  "k_0em8mo0": "Unable to find a playable adaptive bitrate stream",
  "k_0esiak9": "Preview",
  "k_0fdrjph": "Callbacks",
  "k_0flu757": "The player did not find any playable video URLs",
  "k_0fpz2wt": "File ID",
  "k_0h0ym3g": "Timed out getting video data",
  "k_0hqiin4": "For a full list of the callback events, see ",
  "k_0iriiji": "Invalid preview time. Make sure the preview time is within the allowed value range.",
  "k_0jhjcge": "This browser supports WebRTC",
  "k_0kcdczi": "This feature does not work across browsers. For example, after you play a video on a desktop browser, you cannot resume from where you left off on a mobile browser or a different desktop browser. To support checkpoint restart across browsers, please develop your own API based on the feature we provide.",
  "k_0kg3huz": "If a thumbnail is generated for a video, the thumbnail will be used instead of the ad. You can go to the <1>VOD console<\/1> > Audio\/Video Management to view details.",
  "k_0lc49n9": "For directions on how to enable key hotlink protection, see <1>Key Hotlink Protection<\/1>.",
  "k_0lh7uux": "Adaptive bitrate streaming",
  "k_0lq45lv": "When playing an adaptive bitrate streaming HLS file, the player will use the auto quality selection mode by default and will automatically select a bitrate for playback according to bandwidth.",
  "k_0lzvle5": "The player didn't find any playable video data. Please transcode the video first.",
  "k_0mc1279": "Getting a live streaming URL",
  "k_0mltw60": "Failed to download the video due to a network issue",
  "k_0mvjlb5": "Thumbnail previews - upload",
  "k_0njrcbd": "Video quality change messages",
  "k_0ojwjt4": "An internal error occurred during HLS playback",
  "k_0pq59nj": "After you associate subtitles with a video in the cloud, the subtitle file will be loaded automatically when the video is played.",
  "k_0qi3j3c": "DASH playback",
  "k_0qkqz0i": "The parameter \"psign\" is the player signature. For details, see <1>Player Signature<\/1>.",
  "k_0qt08o8": "Getting a video on demand URL",
  "k_0r7dz8t": "Failed to load the video due to a network issue",
  "k_0sju0oc": "To add subtitles in the VOD console, log in to the <1>console<\/1>, select \"Media Assets > Audio\/Video Management\" on the left sidebar, select the target file, and click \"Process\".",
  "k_0t5sx43": "Notes",
  "k_0undtqk": "The VOD media API request timed out",
  "k_0uuad80": "An HLS master playlist allows a device to choose the most appropriate bitrate to play according to network conditions. If video download is fast enough, TS segments with higher bitrates will be played. If not, TS segments with lower bitrates will be played. This feature is supported by most mobile and desktop browsers.",
  "k_0v27h08": "To use the preview feature, you need to enable key hotlink protection. For detailed directions, see <1>Key Hotlink Protection<\/1>.",
  "k_0v3fe2y": "The thumbnails and VTT files generated are auto-generated and passed to the player. For details, see \"Thumbnail previews - upload\".",
  "k_0wcxqcj": "Notes",
  "k_0xwvtqx": "You can use the \"exper\" parameter to specify the length of the preview video segment. Because the preview time is not controlled at the player end, the player will not obtain the full video.",
  "k_0y96gt1": "This browser supports H.264 encoding",
  "k_0yiqkds": "Notes",
  "k_0ymre60": "You can use the initialization parameter \"languages\" to customize error messages. For details, see the table below.",
  "k_0yzdvkm": "Unable to load the video due to unsupported format or a server\/network issue",
  "k_0zwy28a": "Get started",
  "k_101ffsm": "A dynamic watermark moves across a video and may overlap with the video's black bars (if any).",
  "k_10k6s3x": "You can change the video to play using \"loadVideoByID(args)\" after creating an instance of the player object.",
  "k_11j7ygw": "The AppID does not exist. Check the AppID.",
  "k_11wjj41": "Notes",
  "k_125l369": "Video playlist",
  "k_1273spw": "Playback speed change",
  "k_1275jtt": "Video playback",
  "k_127phqp": "Checkpoint restart",
  "k_136c92u": "Do not expose references of the player object globally, or others will be able to remove your dynamic watermarks.",
  "k_13lwn3p": "Statistics",
  "k_13n45zz": "Notes",
  "k_13n78u9": "Notes",
  "k_13nasek": "Notes",
  "k_13ndw2l": "Notes",
  "k_13nnqvh": "Notes",
  "k_13npfig": "Notes",
  "k_13pd56t": "Statistics",
  "k_13vzj4n": "Playback switch",
  "k_14uixkl": "Getting a VOD playback URL",
  "k_14wqpti": "Thumbnail previews - auto generate",
  "k_14zm3l5": "Key hotlink protection",
  "k_1510klj": "Documentation",
  "k_1539km8": "Custom error messages",
  "k_153e7vr": "Message",
  "k_155n6pt": "Mirror",
  "k_156asn6": "Notes",
  "k_157cxwb": "After you enable preview, the player will still display the full length of a video (the preview length is displayed for HLS files on Chrome and Firefox).",
  "k_15duorn": "Video ads",
  "k_15kea92": "Playback URL",
  "k_15lqs7v": "The media file does not exist. Check the file ID.",
  "k_15w4ngo": "Dynamic watermark",
  "k_16ca8qr": "This browser does not support WebRTC",
  "k_17hvv0p": "You can also use CSS to achieve effects such as stretching to fill the container or self-adaptive layouts.",
  "k_17w0lr4": "If you do not specify the width and height, the player size will depend on the resolution of a video. If the viewable area of the browser is smaller than the video size, the player will not be shown in full. We recommend you set the player size using CSS.",
  "k_18w5rr1": "Dynamic watermarks are not suitable for playback on mobile devices, especially if the browser takes control over playback.",
  "k_18xig6b": "A larger number of thumbnails means more precise preview but slower loading.",
  "k_1a5n7l2": "If the browser does not support playback speed change, the player will not display the speed change button.",
  "k_1c1zw6i": "You can set the player size by specifying the width and height attributes of the video tag (in pixels only, such as width = \"100px\" or width = 100).",
  "k_1c95n4n": "Duplicate pcfg",
  "k_1db6c0f": "Playback on iOS is not supported",
  "k_1dmqlhb": "Enter the app ID",
  "k_1ehao7o": "Enter a URL",
  "k_1fx25n4": "Enter the psign",
  "k_1ggmljx": "URL",
  "k_1h5gx2p": "WebRTC, FLV, and HLS are supported for live stream playback. HLS, FLV, and MP4 are supported for video on demand.",
  "k_1hhhesc": "TCPlayer Demo",
  "k_1hsoaa7": "Notes",
  "k_1kb6rai": "This feature allows you to generate thumbnails and VTT files for a video using a server-side API. For details, see <1>Image sprite generating template<\/1>.",
  "k_1kj1wz2": "Video chapters",
  "k_1kq6bhg": "The VOD media API returned abnormal data",
  "k_1lf5ssz": "Notes",
  "k_1lw5sk2": "You can block users from using the full screen button to avoid some cases where dynamic watermarks fail to work because the browser takes control over playback in full screen mode.",
  "k_1nbuhzq": "The VOD media API did not return any data",
  "k_1o0bdon": "This feature saves playback progress using localStorage. Make sure your browser supports this property.",
  "k_1ogc4lc": "Notes",
  "k_1ou4ycy": "Notes",
  "k_1oz0i1l": "The loading of video data was interrupted",
  "k_1prmhzi": "Desktop preview",
  "k_1prw0a6": "Mobile preview",
  "k_1psqlng": "Features",
  "k_1q1rmpf": "Multi-resolution",
  "k_1qrljj0": "Internal error",
  "k_1qsmzip": "Other errors",
  "k_1rafeu0": "Right-click a video to view playback details.",
  "k_1s10v9w": "Media server error",
  "k_1tdf4t0": "Because the actual preview video segment is cut based on keyframes, its length may be shorter than the specified time.",
  "k_1ujmxqw": "This feature is unavailable in cases where the browser takes control over playback.",
  "k_1v8uttc": "Missing hotlink protection information",
  "k_1v9j74o": "Enter the file ID",
  "k_1wto79j": "Enter a playback URL",
  "k_1xnkszg": "Error decoding the video",
  "k_1y09ps1": "You cannot select video quality on browsers that do not offer the corresponding API or do not support MSE. On those browsers, the player will not show video quality options.",
  "k_1ycm4vz": "Notes",
  "k_1z0jw22": "You cannot add subtitles in the console on browsers that do not support MSE.",
  "k_15yy6iv": "Playback control",
  "k_159adlf": "Video security",
  "k_13ajcyd": "Display effect",
  "k_003r5c9": "Barrage",
  "k_15w1p7t": "Ghost watermark",
  "k_121j2ua": "The bullet chat list needs to be maintained and managed on the business side. The front end can request the bullet chat list from the business background, or collect the bullet chat information input by the client user, and display it through the player. Refer to the <1>Documentation<\/1>.",
  "k_0orsgk0": "Ghost watermark is a form of dynamic watermark, which is more secure and concealed.",
  "k_14t3s4i": "Add a set of dot information to the video by modifying the media file attribute interface, refer to the interface <1>document<\/1>.",
  "k_003phiu": "Mirror",
  "k_0ol564c": "Please select the video playback function to experience",
  "k_1608cze": "Advertising stickers",
  "k_0fclyqh": "Custom Prompt Text",
  "k_0ynf2j0": "Player Size Settings",
  "k_034p962": "When playing DASH adaptive bitrate files, the playback definition will adopt the automatic switching logic by default. At this time, the player will dynamically select the most suitable bitrate to play according to the current bandwidth.",
  "k_0e545is": "Allows multiple player instances to be created on one page.",
  "k_1dynwab": "Multiple languages ​​are supported.",
  "k_1biltmy": "Adaptive stream playback",
  "k_0f2e8jf": "Thumbnail preview"
};  

module.exports = { translation: translation };
